import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import { Notifications } from '../../../components/notification/Notifications';


export interface NotificationState {
  notifications: Notifications[]
}

const initialState: NotificationState = {
  notifications: [],
}

export const notificationSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    addNotification: (state, action: PayloadAction<Notifications>) => {
      state.notifications = [...state.notifications, action.payload]
    },
  },
})

// Action creators are generated for each case reducer function
export const {
  addNotification,
} = notificationSlice.actions

export default notificationSlice.reducer
